import React from 'react';
import { Page } from '../Common/Components/Page';
import { ReceivingAreaManagementContent } from './Components/ReceivingAreaManagementContent';

export const ReceivingAreaManagement = (): React.JSX.Element => (
  <Page title="Receiving Areas" accessKey={'ekanbanAreas'} isSearchable={true}>
    <ReceivingAreaManagementContent />
  </Page>
);
